import { Component, inject } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { RoutingInfoService } from '@routing';


//@Todo: this module is not the right place for the component, change it when clean up
@Component({
    selector: 'frame-page',
    template: '<iframe [src]="href" style="width: 100%; height: 100%;border:none;"></iframe>',
    standalone: false
})
export class FramePageComponent {

    #routingInfo: RoutingInfoService = inject(RoutingInfoService);

    #sanitizer: DomSanitizer = inject(DomSanitizer);

    href: any;

    ngAfterViewInit() {
        const config = this.#routingInfo.getCurrentConfigData();
        if(config.frameUrl) {
            if(!config.frameUrl.indexOf('?')) {
                config.frameUrl += '?rand=' + Math.random();
            }
            this.href = this.#sanitizer.bypassSecurityTrustResourceUrl(config.frameUrl);
        }else{
            console.error('Frame url is not defined!')
        }
    }
}